import { Component, OnInit, ViewChild } from '@angular/core';
import { SETTINGS } from 'codefoxhucore';
import { TreeDragDropService, TreeNode } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { filter, takeUntil } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { UnsubscribeComponent } from '../../generals/Components';
import { convertToTreeNodesDepth, expandTreeNodesByIds, getOpenedTreeNodeIds, getTreeNodeParentNodeIdAndBeforeNodeIdByNodeId } from '../../helpers/helper';
import { Category, TreeFindResult } from '../../interfaces/interfaces';
import { CategorydeleteComponent } from '../categorydelete/categorydelete.component';
import { CategoryeditorComponent } from '../categoryeditor/categoryeditor.component';
import { Tree } from 'primeng/tree';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
  providers: [TreeDragDropService, DialogService]
})
export class CategoriesComponent extends UnsubscribeComponent implements OnInit {

  @ViewChild('categoryTree') categoryTree: Tree | null = null;

  categories: Category[] = [];
  categoriesTreeNodes: TreeNode<Category>[] = [];
  dataLoading = false;
  openedTreeNodeIds: (number|string)[] = [];

  constructor(
    private apiService: ApiService,
    private dialogService: DialogService
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadCategories();
  }

  loadCategories(): void {
    this.openedTreeNodeIds = getOpenedTreeNodeIds(this.categoriesTreeNodes);
    this.dataLoading = true;
    this.apiService.getCategories().pipe(takeUntil(this.unsubscribe)).subscribe((rsp) => {
      this.categories = rsp.categories;
      this.categoriesTreeNodes = convertToTreeNodesDepth(this.categories);
      expandTreeNodesByIds(this.categoriesTreeNodes, this.openedTreeNodeIds);
    }).add(() => {
      this.dataLoading = false;
    });
  }

  showCategoryEditorModal(category: Category, parentCategory: Category): void {
    this.dialogService.open(CategoryeditorComponent, {
      width: '500px',
      header: parentCategory !== null ? 'Alkategória hozzáadása - ' + parentCategory.name : category !== null ? 'Kategória szerkesztése - ' + category.name : 'Főkategória hozzáadása',
      data: {
        categoryId: category !== null ? category.id : null,
        parentCategory
      }
    }).onClose.pipe(filter(v => v === true)).subscribe(() => this.loadCategories());
  }

  showCategoryDeleteModal(category: Category): void {
    SETTINGS.precheckInterceptorPrecheck = 'ERROR';
    this.apiService.deleteCategory(category.id).subscribe((rsp) => {
      this.dialogService.open(CategorydeleteComponent, {
        width: '500px',
        header: 'Kategória törlése - ' + category.name,
        data: {
          categoryId: category.id
        }
      }).onClose.pipe(filter(v => v === true)).subscribe(() => this.loadCategories());
    });
  }

  onNodeDrop(event: {originalEvent: DragEvent, dragNode: TreeNode<Category>, dropNode: TreeNode<Category>, dropIndex: number}): void {
    const draggedCategoryId: number = event.dragNode.data.id;
    const treeFindResult: TreeFindResult = getTreeNodeParentNodeIdAndBeforeNodeIdByNodeId(this.categoriesTreeNodes, draggedCategoryId);
    this.apiService.changeCategoryPositions(draggedCategoryId, (treeFindResult.beforeNodeId as number), (treeFindResult.parentNodeId as number)).subscribe({
      next: () => {
        
      },
      error: () => {
        this.loadCategories();
      }
    });
  }

}
